__turbopack_context__.v({
  "icon": "j4NuTq_icon",
  "notClickable": "j4NuTq_notClickable",
  "root": "j4NuTq_root",
});
